module.exports = __webpack_public_path__ + "static/media/service_icon_02.79cc1a22.webp";